import styled from 'styled-components';

export const LogoWrapper = styled.div`
    /* width: 90px; */
    height: auto;
    margin-top: 0px;
    display: flex;
    margin-top: 20px;
    padding-bottom: 20px;
    justify-content: center;

`


export const LogoImg = styled.img`
    line-height: normal;
    position: relative;
    width: 90px;
`

export const QuestionOptions = styled.div`
    display: flex;        
    align-items: stretch;
    flex-direction: column;

    @media (min-width: 960px) {
        margin-bottom: 0;
        overflow: unset;
        padding-bottom: 50px;
    }
`

export const QuestionBlock = styled.div`
    padding: 0 20px;
    text-align: center;

    @media (min-width: 960px) {
        margin-top: 79px;
    }
`

export const Question = styled.h3`
        color: #233034;
        font-size: 18px;
        padding-bottom: 10px;
        text-align: center;
        font-weight: 500;
        font-family: 'Jarkarta', sans-serif;
        
        @media (min-width: 960px) {
            font-size: 24px;
    }
`

export const QSubText = styled.p`
    color: #62727a;
    font-size: 15px;
    padding-bottom: 8px;
`

export const Options = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 16px 0;
    justify-content: center;
    

`

export const Option = styled.div`
    padding: 5px;
    width: 50%;
    display: flex;

    @media (min-width: 52em) {
        width: 25%;
    }
`

export const OptionLabel = styled.label`
display: flex;
    flex: 1 1 auto;
    min-height: 0;
    min-width: 0;
`
export const CheckedContainer = styled.div`
    display: ${props => props.checked ? 'inline' : 'none'};
    position: absolute;
    right: -10px;
    top: -12px;
`
export const StyledOption = styled.div`
    min-height: 72px;
    width: 100%;
    background-color:${props => props.checked ? '#125f3f1a' : '#fff'};
    border:${props => props.checked ? '2px solid #125f3f' : '2px solid rgba(198,204,211,.35)'};
    border-radius: 4px;
    box-shadow: 0 1px 3px 0 rgba(198,204,211,.35);
    padding: 15px;
    justify-content: center;
    position: relative;
    align-items: center;
    flex-direction: column;
    display: flex;

    &:hover {

        border: 2px solid #125f3f;
        cursor: pointer;
    };


    @media (min-width: 960px) {
        height: 148px;
    vertical-align: middle;
    }
`
export const OptionCheckInput = styled.input`
    clip: rect(1px,1px,1px,1px);
    height: 1px;
    overflow: hidden;
    position: absolute!important;
    width: 1px;
`


export const CardContent = styled.div`
    margin-left: 0;
    text-align: center;
    width: 100%;
`

export const CardHeadline = styled.div`
    font-weight: 600;
    width: 100%;
    color:${props => props.checked ? '#125f3f' : '#1b242a'};
`

export const Actions = styled.div`
    background-color: #fff;
    justify-content: center;
    padding: 20px;
    text-decoration: none;
    display: flex;
    margin: 0 auto;

    @media (min-width: 52em) {
        width: 50%;
    }
`

export const SubmitButton = styled.div`
    flex: .5 1 auto;
`

export const CardSubtext = styled.div`
        color: #858585;
    display: block;
    font-size: 14px;
    padding: 0;
`

export const OptionButtonList = styled.ul`
    margin-top: 12px;
    &:hover li:not(:hover) {
    opacity: 0.6;
   }
`
export const OptionButton = styled.li`
    color: #125f3f;
    border: 1px solid #125f3f;
    border-radius: 20px;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.1),0 0 2px 0 rgba(0,0,0,.06);
    // color: #fff;
    cursor: pointer;
    font-size: 16px;
    line-height: 1.5;
    opacity: 1;
    transition: opacity .2s ease-in-out;
    font-weight: 700;
    padding-bottom: .5rem;
    padding-top: .5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    display: inline-block;
    margin-bottom: .5rem;
    margin-right: .5rem;
`

export const OptionsHeader = styled.h2`
color: #383838;
font-size: 16px;
font-weight: 400;
letter-spacing: normal;
line-height: 1.5;
margin-bottom: 12px;
`